import type { AuthLoginResponse, AuthUser } from "@redipos/contracts";
import { http } from "../../shared/http.js";

export const auth = {
  login: (email: string, password: string) =>
    http.post<AuthLoginResponse>("/auth/login", { email, password }),
  me: () => http.get<AuthUser>("/auth/me"),
};
